import { render, staticRenderFns } from "./SpirometriaEditComponent.vue?vue&type=template&id=5cce7a30"
import script from "./SpirometriaEditComponent.vue?vue&type=script&lang=js"
export * from "./SpirometriaEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports